import { render, staticRenderFns } from "./WaBind.vue?vue&type=template&id=6559e669&scoped=true&"
import script from "./WaBind.vue?vue&type=script&lang=js&"
export * from "./WaBind.vue?vue&type=script&lang=js&"
import style0 from "./WaBind.vue?vue&type=style&index=0&id=6559e669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559e669",
  null
  
)

export default component.exports